import { render, staticRenderFns } from "./customer-label-statistics.vue?vue&type=template&id=d4e7b72e&scoped=true&"
import script from "./customer-label-statistics.vue?vue&type=script&lang=js&"
export * from "./customer-label-statistics.vue?vue&type=script&lang=js&"
import style0 from "./customer-label-statistics.vue?vue&type=style&index=0&id=d4e7b72e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e7b72e",
  null
  
)

export default component.exports